<div class="main-container">
  <div class="text-input" [class.invalid]="control.invalid && control.touched">
    <div class="form-floating no-border">
      <input
        [type]="inputType"
        class="form-control"
        [id]="id"
        [placeholder]="placeholder"
        [formControl]="control"
        [class.invalid]="control.invalid && control.touched"
        (keydown)="handleKeyDown($event)"
        (input)="handleInput($event)"
      />
      <label for="floatingPassword"
        >{{ label }}<span *ngIf="required">*</span></label
      >
    </div>
  </div>

  <div *ngIf="control.invalid && control.touched" class="error-message">
    <div *ngIf="control.errors">
      {{ getControlErrorMessage(control) }}
    </div>
    <span class="error-message" *ngIf="errorType == 'mismatch'"
      >The mobile number and/or password is incorrect</span
    >
  </div>
</div>
